// Curated, verified WAM v2 plugins offered as built-in picks (so users don't
// have to hunt/paste URLs). Each URL was confirmed to load as a WAM v2 module.
// The plugin binaries live on their authors' servers (self-hosting third-party
// multi-file webpack plugins isn't practical); the app's own WAM host SDK is
// bundled/self-hosted, so these are the only external piece — inherent to WAM.
export interface WamPreset { name: string; url: string; }

export const WAM_INSTRUMENTS: WamPreset[] = [
  { name: "OB-Xd (Oberheim poly synth)", url: "https://mainline.i3s.unice.fr/wam2/packages/obxd/index.js" },
  { name: "Synth-101 (SH-101 mono synth)", url: "https://www.webaudiomodules.com/community/plugins/burns-audio/synth101/index.js" },
  { name: "DRM-16 DrumComputer", url: "https://www.webaudiomodules.com/community/plugins/burns-audio/drumsampler/index.js" },
  { name: "Soundfont Player", url: "https://www.webaudiomodules.com/community/plugins/burns-audio/soundfont/index.js" },
  { name: "Spectrum: Modal", url: "https://www.webaudiomodules.com/community/plugins/burns-audio/modal/index.js" },
];

export const WAM_EFFECTS: WamPreset[] = [
  { name: "Simple Distortion", url: "https://www.webaudiomodules.com/community/plugins/burns-audio/distortion/index.js" },
  { name: "Big Muff (Fuzz)", url: "https://mainline.i3s.unice.fr/wam2/packages/BigMuff/index.js" },
  { name: "Stone Phaser (Stereo)", url: "https://mainline.i3s.unice.fr/wam2/packages/StonePhaserStereo/index.js" },
  { name: "Randomizer (MIDI/param)", url: "https://www.webaudiomodules.com/community/plugins/burns-audio/randomizer/index.js" },
];
